import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import LoginPage from "@/pages/auth/login/page";
import RegisterPage from "@/pages/auth/register/page";
import ForgotPasswordPage from "@/pages/auth/forgot-password/page";
import ResetPasswordPage from "@/pages/auth/reset-password/page";
import AuthCallback from "@/pages/auth/callback/page";
import AdminDashboard from "@/pages/admin/dashboard/page";
import SellerApprovalPage from "@/pages/admin/vendedores/page";
import SellerDashboard from "@/pages/seller/dashboard/page";
import SuperAdminDashboard from "@/pages/super-admin/page";
import CategoryPage from "@/pages/category/page";
import ProductPage from "@/pages/product/page";
import CartPage from "@/pages/cart/page";
import LegalLayout from "@/pages/legal/components/LegalLayout";
import TermsPage from "@/pages/legal/terms/page";
import PrivacyPage from "@/pages/legal/privacy/page";
import CookiesPage from "@/pages/legal/cookies/page";
import CommunityPage from "@/pages/legal/community/page";
import EmailPreferencesPage from "@/pages/preferences-email/page";
import ProfilePage from "@/pages/profile/page";
import ProfileConfigPage from "@/pages/profile/config/page";
import SellerApplicationPage from "@/pages/seller/application/page";
import PublicProfilePage from "@/pages/public-profile/page";
import MessagesPage from "@/pages/messages/page";
import NotificationsPage from "@/pages/notifications/page";
import ProtectedRoute, {
  AdminRoute,
  SuperAdminRoute,
  SellerRoute,
} from "@/components/feature/ProtectedRoute";
import SiteLayout from "@/components/feature/SiteLayout";

const routes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/categoria/:slug",
        element: <CategoryPage />,
      },
      {
        path: "/producto/:id",
        element: <ProductPage />,
      },
      {
        path: "/carrito",
        element: <CartPage />,
      },
      {
        path: "/preferencias-email",
        element: (
          <ProtectedRoute>
            <EmailPreferencesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/perfil",
        element: (
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/perfil/configuracion",
        element: (
          <ProtectedRoute>
            <ProfileConfigPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/perfil/solicitud-vendedor",
        element: (
          <ProtectedRoute>
            <SellerApplicationPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/perfil/:username",
        element: <PublicProfilePage />,
      },
      {
        path: "/mensajes",
        element: (
          <ProtectedRoute>
            <MessagesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/mensajes/:conversationId",
        element: (
          <ProtectedRoute>
            <MessagesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/notificaciones",
        element: (
          <ProtectedRoute>
            <NotificationsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/legal",
        element: <LegalLayout />,
        children: [
          { index: true, element: <Navigate to="/legal/terms" replace /> },
          { path: "terms", element: <TermsPage /> },
          { path: "privacy", element: <PrivacyPage /> },
          { path: "cookies", element: <CookiesPage /> },
          { path: "community", element: <CommunityPage /> },
        ],
      },
      {
        path: "/admin/dashboard",
        element: (
          <AdminRoute>
            <AdminDashboard />
          </AdminRoute>
        ),
      },
      {
        path: "/admin/vendedores",
        element: (
          <AdminRoute>
            <SellerApprovalPage />
          </AdminRoute>
        ),
      },
      {
        path: "/super-admin",
        element: (
          <SuperAdminRoute>
            <SuperAdminDashboard />
          </SuperAdminRoute>
        ),
      },
      {
        path: "/seller/dashboard",
        element: (
          <SellerRoute>
            <SellerDashboard />
          </SellerRoute>
        ),
      },
    ],
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/registro",
    element: <RegisterPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/auth/callback",
    element: <AuthCallback />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;